angular.module('omega').service('DiscoveryService', function (API_BASE_URL, MAX_CONCEPTS_FOR_FAST_DISCOVERY_REQUEST, $http, $filter, SimplifyService) {

    this.list = function (searchProfileId, collections, precision, dateFrom, dateTo, concepts, mode) {
        return $http({
            url: API_BASE_URL + 'discover.xqy',
            method: 'POST',
            data: this.buildFormData(searchProfileId, collections, precision, dateFrom, dateTo, concepts, mode)
        }).then(function (results) {
            return SimplifyService.simplifyDiscoveryList(results);
        });
    };

    this.listRelated = function (searchProfileId, collections, precision, dateFrom, dateTo, concepts) {
        return this.list(searchProfileId, collections, precision, dateFrom, dateTo, concepts, 'topics-related')
    };

    this.listNeighbours = function (searchProfileId, collections, precision, dateFrom, dateTo, concepts) {
        return this.list(searchProfileId, collections, precision, dateFrom, dateTo, concepts, 'geo-neighbours')
    };

    this.listNonRelated = function (searchProfileId, collections, precision, dateFrom, dateTo, suggestedConcepts, originalConcepts) {

        var concepts = suggestedConcepts ? angular.copy(suggestedConcepts) : [];
        
        // we remove geographical suggested Concepts
        for (var i = concepts.length - 1; i >= 0; i--) {
            if (concepts[i].pattern == 'geographical') {
                concepts.splice(i, 1);
            }
        }

        // if we have too much concepts we remove less relevant ones
        if (concepts.length > MAX_CONCEPTS_FOR_FAST_DISCOVERY_REQUEST) {
            // we splice all elements with a count below average
            var totalCount = 0;
            for (var i = 0; i < concepts.length; i++) {
                totalCount += concepts[i].count;
            }
            var average = totalCount / concepts.length;
            // we loop backwards to prevent shifting values to splice
            for (var i = concepts.length - 1; i >= 0; i--) {
                if (concepts[i].count < average) {
                    concepts.splice(i, 1);
                }
            }
        }

        // we add geographical concepts from original concepts
        for(var i = 0; i < originalConcepts.length; i++) {
            concepts.push(originalConcepts[i]);
        }

        return $http({
            url: API_BASE_URL + 'discover.xqy',
            method: 'POST',
            data: this.buildFormData(searchProfileId, collections, precision, dateFrom, dateTo, concepts, 'topics-non-related'),
            headers: {'Content-Type': undefined} // prevent changing content-type
        }).then(function (results) {
            return SimplifyService.simplifyDiscoveryList(results);
        });
    };

    this.buildFormData = function (searchProfileId, collections, precision, dateFrom, dateTo, concepts, mode) {

        dateFrom = typeof dateFrom != 'undefined' ? dateFrom : null;
        dateTo = typeof dateTo != 'undefined' ? dateTo : null;

        // select and format searchProfile's collections
        var collectionUris = [];
        collections.forEach(function (item) {
            if (item.searchProfileId == searchProfileId) {
                collectionUris.push(item.uri);
            }
        });
        collectionUris = collectionUris.join('|');

        var formData = new FormData();
        formData.append("searchProfile", searchProfileId);
        formData.append("targetCollections", collectionUris);
        formData.append("precision", precision);
        if (dateFrom) {
            formData.append('dateFrom', $filter('date')(dateFrom, "yyyy-MM-dd"));
        }
        if (dateTo) {
            formData.append('dateTo', $filter('date')(dateTo, "yyyy-MM-dd"));
        }
        if (mode) {
            formData.append('mode', mode);
        }
        for (var i = 0; i < concepts.length; i++) {
            formData.append("originalConcept", concepts[i].uri)
        }

        return formData;
    }

});